/**
 * Another clever approach of writing reducers:
 *
 * export default function(state = initialState, action) {
 *   const actions = {
 *      [ACTION_TYPE]: () => [action.payload.data, ...state]
 *   };
 *
 *   return (_.isFunction(actions[action.type])) ? actions[action.type]() : state
 * }
 */

import * as types from '../constants/ActionTypes';
import { assign, omit } from 'lodash';

const initialState = {};

const reduceImage = (state = {}, action) => {
  switch (action.type) {
    case types.REPORT_IMAGE_SIZE:
      return {...state, size: action.size};
    case types.REPORT_IMAGE_DIMENSIONS:
      return {...state, width: action.width, height: action.height};
    default:
      return state;
  }
};

export default function (state = initialState, action) {
  let currentImageState, newImageState, newState;
  switch (action.type) {
    case types.REPORT_IMAGE_SIZE:
    case types.REPORT_IMAGE_DIMENSIONS:
      newImageState = reduceImage(state[action.imageId], action);
      newState = {...state};
      newState[action.imageId] = newImageState;
      return newState;
    case types.RESET_DEMO_IMAGE:
      return omit(state, action.imageId);        
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/demoImages.js
 **/